import api from './api';
import idbService from './idbService';
import { LOCAL_STORAGE_PREFIX } from '../utils/utils';

export const usuarioService = {
  getLicencas,
  getBackups,
  setBackups,
  verifyCurrentUserToClearIndexedDb
};

function getLicencas(id_usuario) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/usuarios/${id_usuario}/licencas`);
}

function getBackups(id_usuario, acao) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/usuarios/${id_usuario}/backups?acao=${acao}`);
}

function setBackups(id_usuario, acao, registros) {
  return api.patch(`${process.env.VUE_APP_ROOT_API}/usuarios/${id_usuario}/backups`, {
    acao,
    dados: {
      [acao]: registros
    }
  });
}

async function verifyCurrentUserToClearIndexedDb(email) {
  const lastUsuario = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}:usuario`);

  if (lastUsuario && lastUsuario !== email) {
    await idbService.destroyDb();
    return true;
  }

  return false;
}